function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectSeatSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.834 13.696a2.976 2.976 0 01-2.976 2.976H7.143a2.976 2.976 0 01-2.976-2.976V2.98A2.976 2.976 0 017.143.005h10.715a2.976 2.976 0 012.976 2.976v10.715z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.619 16.678V8.336h2.38L25 11.408v5.3c0 1.135-.802 1.888-1.548 2.337-.776.468-1.8.81-2.911 1.064-2.242.513-5.169.743-8.049.726-2.88-.017-5.802-.283-8.038-.803-1.107-.258-2.124-.596-2.892-1.045C.845 18.568 0 17.841 0 16.707V8.337h2.38v8.304c.035.045.133.146.383.291.468.274 1.218.546 2.231.782 2.006.467 4.739.724 7.513.741 2.775.017 5.503-.209 7.502-.666 1.01-.231 1.753-.504 2.214-.782.286-.172.373-.287.396-.328zm.007-.017s0 .003-.004.01l.004-.01zm-20.262-.047l.004.008a.026.026 0 01-.004-.008z",
    fill: props.fill
  }));
}
export default SvgSelectSeatSmall;